export const getRequestMicrosoftGraphUrls = (
): string[] => {
    const urlParams = new URLSearchParams(window.location.search);

    let items = urlParams.get('items');
    return JSON.parse(items);
};
